import CheckMark from "./CheckMark.png";

const checkMark = () => {
  return (
    <div>
      <img src={CheckMark} alt="checked" width="20px" height="20px" />
    </div>
  );
};

export default checkMark;
